import { buildingsRoutes } from "routes/buildings-routes";
import { authRoutes } from "routes/auth-routes";
import { dashboardAndOthers } from "routes/dashboard-others-routes";
import { brandRoutes } from "routes/brand-routes";
import { usersRoutes } from "routes/users-routes";
import { giotanksRoutes } from "routes/giotanks-routes";
import { customerRoutes } from "routes/customer-routes";
import { comoDataRoutes } from "routes/comodata-routes";
import { marketingRoutes } from "routes/marketing-routes";
import { mapRoutes } from "routes/map-routes";
import { crmRoutes } from "routes/crm-routes";
import { pricesRoutes } from "routes/prices-routes";
import { monetizationRoutes } from "routes/monetization-routes";
import { unitsRoutes } from "routes/units-routes";
import { tanksRoutes } from "routes/tanks-routes";
import { orderRoutes } from "routes/orders-routes";
import { expensesRoutes } from "routes/expenses-routes";
import { reportRoutes } from "routes/reports-routes";
import { carburetionRoutes } from "routes/carburetion-routes";
import { prePayRollRoutes } from "routes/prepayroll-routes";
import { catalogsRoutes } from "routes/catalogs-routes";
import { purchasesRoutes } from "routes/purchases-routes";
import { salesRoutes } from "routes/sales-routes";
import { inventoriesRoutes } from "routes/inventories-routes";
import { surveysRoutes } from "routes/surveys-routes";
import { invoicesRoutes } from "routes/invoices-routes";
import { devRoutes } from "routes/dev-routes";
import { integrationsRoutes } from "routes/integrations-routes";
import { supportRoutes } from "routes/support-routes";
import { routesRoutes } from "routes/routes-routes";
import { commissionRoutes } from "routes/commission-routes";

var dashRoutes = [
  // auth
  ...authRoutes,
  ...dashboardAndOthers,
  ...brandRoutes,
  ...usersRoutes,
  ...giotanksRoutes,
  ...customerRoutes,
  ...comoDataRoutes,
  ...marketingRoutes,
  ...mapRoutes,
  ...crmRoutes,
  ...pricesRoutes,
  ...monetizationRoutes,
  ...unitsRoutes,
  ...tanksRoutes,
  ...orderRoutes,
  ...expensesRoutes,
  ...reportRoutes,
  ...carburetionRoutes,
  ...prePayRollRoutes,
  ...catalogsRoutes,
  ...purchasesRoutes,
  ...salesRoutes,
  ...inventoriesRoutes,
  ...surveysRoutes,
  ...invoicesRoutes,
  ...integrationsRoutes,
  ...supportRoutes,
  ...buildingsRoutes,
  ...devRoutes,
  ...routesRoutes,
  ...commissionRoutes
].sort((a, b) => (a.name < b.name ? -1 : 1));
export default dashRoutes;
